import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import QRCode from "react-qr-code";
import { Images } from "./../../assets/common";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { copyToClipboard } from "../../constants/function";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
export default function QrCode({ params, value }) {
  const { t } = useTranslation("common");
  const [copied, setCopied] = React.useState(null);
  const handleCopy = (data) => {
    setCopied(copyToClipboard(data));
    setTimeout(() => {
      setCopied(null);
    }, 2000);
  };
  useEffect(() => {}, [copied]);
  return (
    <Box
      sx={{
        height: "90vh",
        padding: "1rem",
        maxWidth: "270px",
        margin: "auto",
      }}
    >
      <Typography align="center">{t("qrPopup.text1")}</Typography>
      <Box sx={{ marginTop: "1rem", textAlign: "center" }}>
        <QRCode
          value={`${params["walletId"]}`}
          bgColor="#000000"
          fgColor="yellow"
        />
      </Box>
      <Box sx={{ marginTop: "1rem" }}>
        <Typography align="left" variant="h6">
          {t("qrPopup.text2")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "5px",
            borderRadius: "4px",
            border: "1px solid",
          }}
        >
          <Typography sx={{ wordBreak: " break-all" }}>
            {value === "hbar" ? params["hbar"] : params["usdc"]}
          </Typography>
          <Tooltip title={copied == null ? "" : "Copied"} leaveDelay={1000}>
            <ContentCopyOutlinedIcon
              className="_cp"
              onClick={() =>
                handleCopy(value === "hbar" ? params["hbar"] : params["usdc"])
              }
            >
              Outlined
            </ContentCopyOutlinedIcon>
          </Tooltip>
        </Box>
      </Box>
      <Box sx={{ marginTop: "1rem" }}>
        <Typography align="left" variant="h6">
          {t("qrPopup.text4")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "5px",
            borderRadius: "4px",
            border: "1px solid",
            backgroundColor: "#ffffff",
          }}
        >
          <Typography color="secondary">{params["walletId"]}</Typography>
          <Tooltip
            title={copied == null ? "" : t("qrPopup.tooltip")}
            leaveDelay={1000}
          >
            <ContentCopyIcon
              className="_cp"
              onClick={() => handleCopy(`${params["walletId"]}`)}
              color="secondary"
            ></ContentCopyIcon>
          </Tooltip>
        </Box>
        <Box sx={{ marginTop: "1rem" }}>
          <Typography color="primary" sx={{ textAlign: "justify" }}>
            {t("qrPopup.text5")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
